import styled from 'styled-components'

export const EmptyTD = styled.td`
	background-color: white;
`
